import { useEffect } from 'react';
import { Outlet, useParams, Navigate } from 'react-router';
import { AppShell } from './app-shell';
import { setActiveTenant } from '@/lib/api/client';
import { useAuthStore } from '@/features/auth/auth.store';

export function TenantShell() {
  const { condoId } = useParams<{ condoId: string }>();
  const session = useAuthStore((s) => s.session);

  useEffect(() => {
    setActiveTenant(condoId ?? null);
    return () => setActiveTenant(null);
  }, [condoId]);

  if (!session || !condoId) return null;

  // Defensive: backend 403s if user has no membership, but this keeps UX clean.
  if (!session.isSuperAdmin && !session.tenants[condoId]) {
    return <Navigate to="/app/no-access" replace />;
  }

  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
